import * as React from 'react';
import classNames from "classnames";
import { TreeNode } from "../index";
import AnimateHeight from 'react-animate-height';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import './Tree.scss';

interface ITreeProps {
    treeData: ITree;
    onToggle: (id: string, navigate?: boolean) => void;
    toggleState: string[];
    subTree?: boolean;
    toggled?: boolean;
}

export interface ITree {
    children: ITreeNode<any>[];
}

export interface ITreeNode<T> {
    id: string;
    data: T | React.ReactNode;
    icon: IconDefinition;
    decorator?: (node: ITreeNode<T>, toggled: boolean, onToggle: (id: string, navigate?: boolean) => void) => React.ReactElement;
    subTree?: ITree;
    onToggle?: (id: string, navigate?: boolean) => void;
    collapsible: boolean;
}

class Tree extends React.PureComponent<ITreeProps> {
    constructor(props: ITreeProps) {
        super(props);
    }

    render() {
        const { treeData, onToggle, toggleState, subTree, toggled } = this.props;

        if (!treeData) {
            return null;
        }

        const tree = (
            <ul className={classNames({ "tree": !subTree }, { "sub-tree": subTree })}>
                {treeData.children?.map((treeNode) => {
                    const itemToggled = toggleState.includes(treeNode.id);
                    const toggle = treeNode.onToggle || onToggle;

                    const node = treeNode.decorator
                        ? treeNode.decorator(treeNode, itemToggled, toggle)
                        : (
                            <TreeNode
                                id={treeNode.id}
                                name={treeNode.data}
                                icon={treeNode.icon}
                                onToggle={onToggle}
                                toggled={itemToggled}
                                collapsible={treeNode.collapsible}
                            />
                        );

                    return (
                        <li key={treeNode.id}>
                            {node}
                            {treeNode.subTree && (
                                <Tree
                                    treeData={treeNode.subTree}
                                    onToggle={toggle}
                                    toggleState={toggleState}
                                    subTree={true}
                                    toggled={itemToggled}
                                />
                            )}
                        </li>
                    );
                })}
            </ul>
        );

        return subTree ? (
            <AnimateHeight duration={500} height={toggled ? "auto" : "0%"}>
                {tree}
            </AnimateHeight>
        ) : tree;
    }
}

export default Tree;
